import PaymentMethodsSelect from "src/components/payment-methods-select/payment-methods-select";

export function PaymentSettings() {
	return <PaymentMethodsSelect />;
}
